/// <amd-module name="SuiteCommerce.PhotoGallery.CCT.BaseView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PhotoGallery.CCT.BaseView", ["require", "exports", "photogallery.tpl", "SuiteCommerce.PhotoGallery.Photo.Collection", "SuiteCommerce.PhotoGallery.CCT.Settings", "SuiteCommerce.Photo.Model", "SuiteCommerce.PhotoGallery.Gallery.View", "CustomContentType.Base.View", "jQuery"], function (require, exports, photoGalleryTemplate, PhotoGallery_Photo_Collection_1, PhotoGallery_CCT_Settings_1, PhotoGallery_Gallery_Model_1, PhotoGallery_Gallery_View_1, CustomContentTypeBaseView, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PhotoGalleryCCTBaseView = /** @class */ (function (_super) {
        __extends(PhotoGalleryCCTBaseView, _super);
        function PhotoGalleryCCTBaseView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = photoGalleryTemplate;
            _this.container = options && options.container;
            return _this;
        }
        Object.defineProperty(PhotoGalleryCCTBaseView.prototype, "childViews", {
            get: function () {
                return {
                    GalleryView: function () {
                        var photoGalleryCollectionAttributes = this.cctSettings.getImagesAttributes();
                        var photosCollection = new PhotoGallery_Photo_Collection_1.PhotoCollection(photoGalleryCollectionAttributes);
                        var galleryModel = new PhotoGallery_Gallery_Model_1.GalleryModel({
                            photosCollection: photosCollection,
                            isCarouselEnabled: this.cctSettings.isCarouselEnabled(),
                            openLinksInNewWindow: this.cctSettings.openLinksInNewWindow(),
                            galleryHeightClassName: this.cctSettings.getGalleryHeightClass(),
                            galleryStyle: this.cctSettings.getGalleryStyle(),
                            imageHoverAnimationType: this.cctSettings.getImageHoverAnimationType(),
                            carouselAnimationTime: this.cctSettings.getCarouselAnimationTime(),
                            columnsPerRow: this.cctSettings.getColumnsPerRow(),
                        });
                        return new PhotoGallery_Gallery_View_1.GalleryView({
                            model: galleryModel,
                            container: this.container,
                        });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        PhotoGalleryCCTBaseView.prototype.install = function (settings, contextData) {
            this.cctSettings = new PhotoGallery_CCT_Settings_1.PhotoGalleryCCTSettings(settings, this.container);
            return jQuery.Deferred().resolve();
        };
        PhotoGalleryCCTBaseView.prototype.update = function (settings) {
            this.cctSettings = new PhotoGallery_CCT_Settings_1.PhotoGalleryCCTSettings(settings, this.container);
            return jQuery.Deferred().resolve();
        };
        return PhotoGalleryCCTBaseView;
    }(CustomContentTypeBaseView));
    exports.PhotoGalleryCCTBaseView = PhotoGalleryCCTBaseView;
});
